import './App.css';
import Home from './components/Home/Index';
import PageNotFound from './components/Shared/PageNotFound';
function App() {
  const path = window.location.pathname;

  const RenderComponent = () => {
    switch (path) {
      case '/':
        return <Home />
      case '/home':
        return <Home />
      default:
        return <PageNotFound />
    }
  }
  return (
    <RenderComponent />
  );
}
export default App;